// Debounce function to prevent excessive calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Throttle function for scroll events
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// Debounced resize handler
const debouncedResize = debounce(function() {
  bodyPadding();
  pointPos();
}, 250);

// Throttled scroll handler
const throttledScroll = throttle(function() {
  var st = $(window).scrollTop();
  if (st == 0) {
    bodyPadding();
  }
}, 100);

$(window).on('load', function() {
  bodyPadding();
  pointPos();
});

$(window).on('resize', debouncedResize);
$(window).on('scroll', throttledScroll);

$('body').click(function(){
  setTimeout(function(){
    pointPos();
  },1);
});

$('body').click(function(){
  setTimeout(function(){
    pointPos();
  },300);
});

$('.announce_bar').click(function(){
  setTimeout(function(){
    pointPos();
  },300);
});

// Cache jQuery selectors
const $body = $('body');
const $main = $('main');
const $header = $('header');
const $footer = $('footer');
const $window = $(window);
const $headerCartBtn = $('.header_cart_btn');
const $mrpointEmbed = $('.mrpoint-embed');

function bodyPadding() {
  var headerHeight = $header.height();
  var footerHeight = $footer.height();
  $body.css('padding-top',headerHeight+'px');
  $main.css('min-height','calc(100vh - '+headerHeight+'px - '+footerHeight+'px)');
}

function pointPos() {
  // Check if elements exist before calculating
  if (!$headerCartBtn.length || !$mrpointEmbed.length) return;
  
  var windowWidth = $window.width();
  var cartOffset = $headerCartBtn.offset();
  if (!cartOffset) return;
  
  var cartPos = cartOffset.left;
  var cartPos2 = windowWidth - cartPos;
  var headerPosY = $header.offset().top;
  var cartPosY = cartOffset.top;
  var cartPosY2 = cartPosY - headerPosY;
  var pointPos = cartPos2 + 12;
  var pointPosY = cartPosY2 + 5;
  var maxWidth = windowWidth - pointPos -10;
  $mrpointEmbed.css({
    'right': pointPos+'px',
    'top': pointPosY+'px',
    'max-width': maxWidth+'px'
  });
}

$(function(){
$(window).scroll(function () {
    var now = $(window).scrollTop();
    if (now > 400) {
      $(".top_btn").fadeIn();
    } else {
      $(".top_btn").fadeOut();
    }
  });
  $(document).on("click", ".top_btn", function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      200
    );
    return false;
  });
});





var commonBeforePos = 0;//スクロールの値の比較用の設定

//スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
function ScrollAnime2() {
  var elemTop = 300;//#area-2の位置まできたら
  var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if(scroll == commonBeforePos) {
    //IE11対策で処理を入れない
    }else if(elemTop > scroll || 0 > scroll - commonBeforePos){
    //ヘッダーが上から出現する
      $('.header_search').slideDown(0);
    }else {
    //ヘッダーが上に消える
      $('.header_search').slideUp(0);
    }
    commonBeforePos = scroll;//現在のスクロール値を比較用のcommonBeforePosに格納
}

// Throttled scroll handler for header animation
const throttledScrollAnime2 = throttle(function() {
  if($('body').css('min-width')=='2px'){
    ScrollAnime2();
  }
}, 100);

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(throttledScrollAnime2);

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  if($('body').css('min-width')=='2px'){
    ScrollAnime2();
  }
});




$('.variant-picker__option-values').change(function() {
  $('.point_num').css('opacity','0');
  setTimeout(function(){
        var price = $('.point_num').html();
        var result = Number( price.replace(/,/, '') );
        var priceNum = Number(result);
        var point = priceNum / 110;
        var pointNum = Math.floor(point);

          $('.point_num').html(pointNum);
          $('.point_num').css('opacity','1');
        },1);
});



$(function(){
    var greeting = "こんにちは";

  $('.login_customer').prepend(greeting);



    $('.announce_message').click(function(){
    $('.announce_box').slideDown(300);
    $('header').css('z-index','901');
    $('header').append('<div class="announce_bg"></div>');
    $('.announce_bg').click(function(){
      $('.announce_box').slideUp(300);
      setTimeout(function(){
        $('header').css('z-index','10');
      },300);
    $(this).remove();
  });
  });


  $('.announce_close_btn').click(function(){
    $('.announce_bar').slideUp(300);
  });

});

